import { FC } from 'react'

import { ISvgClass } from '../interface'

const PushPinIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="24px"
      height="24px"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="inherit"
        stroke="none"
      >
        <path d="M1400 4788 c-75 -21 -130 -109 -114 -181 3 -18 112 -208 240 -422 l234 -390 0 -433 0 -432 -373 -448 c-205 -246 -383 -460 -395 -477 -12 -16 -24 -48 -27 -70 -8 -51 26 -120 74 -152 l34 -23 663 0 663 0 3 -669 c3 -662 3 -670 24 -698 71 -96 207 -99 270 -5 18 25 19 66 24 697 l5 670 670 5 670 5 31 22 c53 38 76 111 58 181 -4 13 -184 236 -400 495 l-394 472 0 427 0 427 237 393 238 393 0 62 c0 70 -19 104 -76 138 -33 20 -54 20 -1179 22 -736 1 -1157 -2 -1180 -9z m1997 -315 c-2 -5 -82 -138 -178 -298 l-174 -290 -3 -505 c-2 -365 0 -516 9 -545 8 -29 93 -138 306 -393 162 -195 293 -356 290 -358 -2 -2 -492 -3 -1089 -2 l-1085 3 298 358 c210 253 300 368 304 390 3 18 5 264 3 547 l-3 515 -172 287 c-95 157 -173 289 -173 292 0 3 376 6 836 6 459 0 833 -3 831 -7z" />
      </g>
    </svg>
  )
}

export default PushPinIcon
